export default "__VITE_ASSET__1a13c8cc__"